var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlogPublic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 29C22.732 29 29 22.732 29 15C29 7.268 22.732 1 15 1C7.268 1 1 7.268 1 15C1 22.732 7.268 29 15 29Z",
    stroke: "#2064A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20581 12.6079C2.55794 15.0105 9.82723 16.2408 9.00189 20.0981C8.35711 23.1118 7.4935 24.8286 8.80235 27.5535",
    stroke: "#2064A1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2629 1.18408C17.2629 1.18408 11.998 3.87842 13.3548 7.42985C14.1084 9.31383 20.5743 8.40468 22.2271 9.23115C22.6354 9.43524 24.1417 13.0701 25.2039 12.4328C27.6401 10.9711 27.1962 8.12629 27.1962 8.12629",
    stroke: "#2064A1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0557 20.0541C26.611 19.2447 24.3068 19.04 22.9357 18.0866C20.9386 16.6978 20.8008 14.204 18.3277 14.0052C15.6727 13.7921 12.7415 16.6273 14.5096 18.8765C16.9286 21.9538 18.3088 24.9488 17.0685 28.8463",
    stroke: "#2064A1",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlogPublic);
export default __webpack_public_path__ + "static/media/icon_blog_public.ee0b798392cd9ffd5c0f8ec2d56a7747.svg";
export { ForwardRef as ReactComponent };